export const DOM_IDS = {
  FOOTER_CONTAINER: 'simplified-footer-copyright',
  CONTENT_CONTAINER: 'content_container'
}

export const SELECTORS = {
  MINIMALIST_MOUNT: '.mini-layout > .mini-layout-body',
  CONTENT_BODY: '.mini-layout-body > .row > .content-body'
}

export const MINIMALIST_CLASS = 'is-minimalist'
